import React, { useState } from 'react';
import Grid from "@mui/material/Grid2";

import { 
  Campaign, 
} from "@dndModels";

import ModalOrDrawer from "@components/display/ModalOrDrawer";
import NotesButton from '@components/input/buttons/NotesButton';
import CampaignNotesInput from '@dndComponents/campaign/notes/CampaignNotesInput';
import { DataType } from '@dndModels/Types';

interface Props {
  campaign: Campaign;
  on_type?: DataType;
  on_id?: string;
}

export default function CampaignNotesButton({
  campaign,
  on_type,
  on_id
}: Props) {
  const [open, setOpen] = useState(false);

  const renderExtras = () => {
    return (
      <ModalOrDrawer
        open={ open } 
        onClose={() => {
          setOpen(false);
        }}>
        <CampaignNotesInput
          campaign={campaign}
          on_type={on_type}
          on_id={on_id}
        />
      </ModalOrDrawer>
    );
  }

  return (
    <>
      <NotesButton
        onClick={() => { setOpen(true); }}
      />
      { renderExtras() }
    </>
  ); 
}

